import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject, featuredProjectsList } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const BandstandNewcastleHelix = ({featuredProjectsList}) => {
  const project = getProject('bandstand-newcastle-helix');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          component={{
            posterVideo: '310787140'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="an-ambitious-real-estate-project">
            An ambitious real estate project
          </h2>
          <p>
            Newcastle Helix brings together academia, the public sector,
            business, and industry to form a global, sustainable center for
            urban innovation.{' '}
          </p>
          <p>
            With a focus on data and urban science, the city of Newcastle aims
            to set a new standard for transforming the quality of life for its
            inhabitants.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20190201200919/helix_aerial.jpg',
            calculateRatio: '1920,966',
            caption: 'The Helix combines prestigious commercial and residential space \
                      with first-class research and education facilities in the heart of Newcastle.'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            We were asked by Bandstand, a creative agency in London, to help
            them to bring the brand and communication strategy to life.{' '}
          </p>
          <p>
            Together, we created an ever-changing generative brand identity that
            is fueled by real-time data from the Helix itself.
          </p>
        </AnimateIn>

        <VimeoVideo
          component={{
            posterVideo: '315092645'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="expressing-the-city-of-newcastle">
            Expressing the city of Newcastle
          </h2>
          <p>
            With multiple real-time datasets at our disposal, we created a
            living logo that mimics the ecosystem and behavior of Newcastle and
            the people that reside in the city.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20190205093417/helix-process1.png'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            The identity is continuously updating and renders new logo updates
            to all digital touchpoints every 15 minutes.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20190201154734/helix-phones.png'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            On the website, as well on interactive kiosks, users can explore the
            different data points, and see how the identity has evolved in the
            past 24 hours.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20190205092108/helix-photos1.png'
          }}
        />

        <VimeoVideo
          component={{
            posterVideo: '315092900',
            calculateRatio: 'auto',
            caption:
              'Newcastlehelix.com is a bespoke design, built from scratch using Contentful CMS.'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="partners">Partners</h2>
          <p>
            <a href="http://www.bandstand.co.uk" target="_blank" rel="noopener">
              Bandstand London
            </a>
            <br />
            <a href="http://www.newcastlehelix.com" target="_blank" rel="noopener">
              Newcastle Helix
            </a>
          </p>

          <h2 id="like-what-you-see-">Like what you see?</h2>
          <p>
            Email us to{' '}
            <a href="mailto:hello@yourmajesty.co">
              hello@yourmajesty.co
            </a>
            <br />
            to book a consultation on your next project.
          </p>
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: [
                  'Prototyping & Validation',
                  'Technical Strategy',
                  'UX Strategy',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: [
                  '3D Animation',
                  '3D Design',
                  'Art Direction',
                  'Motion Design',
                  'Visual Design'
                ]
              },

              {
                title: 'Technology',
                items: [
                  'Back-end Development',
                  'Content Management System',
                  'Front-end Development',
                  'Functional Prototyping',
                  'Localization',
                  'Systems Architecture',
                  'WebGL'
                ]
              },

              {
                title: 'Delivery',
                items: [
                  'Analytics & Insights',
                  'Integration Support',
                  'Launch',
                  'Quality Assurance',
                  'Quantitative and Qualitative Analysis'
                ]
              },

              {
                title: 'Content',
                items: ['Animation']
              },

              {
                title: 'Experiential',
                items: [
                  'Hardware Specification',
                  'Installation Prototyping',
                  'Interactive Environment'
                ]
              }
            ]
          }}
        />

        <LinkButton
          className="g-row"
          component={{
            url: 'https://www.newcastlehelix.com',
            title: 'Visit website'
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default BandstandNewcastleHelix;
